var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1579,
    cy: 9.55606,
    r: 9.55606,
    fill: "#101A20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2363e-05 32.4027C-0.00253521 31.731 0.147706 31.0674 0.439392 30.4622C1.35472 28.6316 3.93596 27.6613 6.07784 27.222C7.62255 26.8923 9.18861 26.6721 10.7643 26.5629C13.6817 26.3067 16.6159 26.3067 19.5332 26.5629C21.1088 26.6734 22.6748 26.8936 24.2197 27.222C26.3616 27.6613 28.9428 28.54 29.8582 30.4622C30.4447 31.6958 30.4447 33.128 29.8582 34.3616C28.9428 36.2837 26.3616 37.1625 24.2197 37.5835C22.6768 37.9268 21.1102 38.1532 19.5332 38.2609C17.1587 38.4622 14.7732 38.4989 12.3936 38.3707C11.8444 38.3707 11.3135 38.3707 10.7643 38.2609C9.19326 38.1546 7.63264 37.9281 6.09614 37.5835C3.93596 37.1625 1.37303 36.2837 0.439392 34.3616C0.149197 33.7494 -0.000895896 33.0802 3.2363e-05 32.4027Z",
    fill: "#101A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFilled);
export default __webpack_public_path__ + "static/media/profile-filled.26136488d1528a05770f64613aa55085.svg";
export { ForwardRef as ReactComponent };